const element = document.querySelector('.module-calendar-teaser .overview');

element.parentNode.removeChild(element);

/**
 * @param {HTMLDivElement} wrapper Der .kdo-modules-container
 */
window.kdoCalendarTeaserCallback = wrapper => {
  element.style.display = 'block';
  wrapper.appendChild(element);
};
